import { render, staticRenderFns } from "./AdminEditSchool.vue?vue&type=template&id=25938ac0&scoped=true&"
import script from "./AdminEditSchool.vue?vue&type=script&lang=js&"
export * from "./AdminEditSchool.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditSchool.vue?vue&type=style&index=0&id=25938ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25938ac0",
  null
  
)

export default component.exports